import { pickBy } from 'lodash';

import {
  getGuid,
  getRole,
  getEmail,
  getUserName,
  getLastName,
  getFirstName,
  getUserDistrictName,
  getUserDistrictId,
} from 'State/selectors';
import { token } from 'API/MPWApi';

export const init = (apiKey = process.env.REACT_APP_PENDO_API_KEY) => (
  dispatch,
  getState
) => {
  try {
    if (!window.hasOwnProperty('pendo')) {
      injectLibrary(apiKey);
    }
  } catch (e) {
    throw Error(
      `There was an issue installing Pendo's library. https://help.pendo.io/resources/support-library/installation/single-page.html`
    );
  }

  const state = getState();

  if (token.isValid()) {
    initialize(state);
  }
};

const injectLibrary = apiKey => {
  (function(p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    for (w = 0, x = v.length; w < x; ++w)
      (function(m) {
        o[m] =
          o[m] ||
          function() {
            o._q[m === v[0] ? 'unshift' : 'push'](
              [m].concat([].slice.call(arguments, 0))
            );
          };
      })(v[w]);
    y = e.createElement(n);
    y.async = !0;
    y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
};

const initialize = state => {
  window.pendo.initialize({
    visitor: pickBy({
      id: getEmail(state) || getGuid(state), // Required if user is logged in
      name: `${getFirstName(state)} ${getLastName(state)}`,
      email: getEmail(state),
      username: getUserName(state),
      role: getRole(state),
      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
    }),

    account: pickBy({
      id: getUserDistrictName(state), // Highly recommended
      districtName: getUserDistrictName(state),
      districtId: getUserDistrictId(state),

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    }),
  });
};



// WEBPACK FOOTER //
// ./src/containers/app/Pendo.js